const variables = ['gutterWidth', 'sectionMargin', 'sitePadding', 'siteWidth'];
function cssVar(name) {
    return `var(--${name})`;
}
function setCssVar(name, value) {
    return `--${name}: ${value}`;
}
export { cssVar, setCssVar };
